import { CollectionName } from '../../constants';
import { migrateCollections } from '../helpers';
import {
  CurrentMigrationCollectionItem,
  MigratedMigrationCollectionItem,
  MigrationType,
  SingleCollectionMigrationOption,
} from '../types';

const valueFields = [
  'purchaseValue',
  'currentMarketValue',
  'availableLimit',
  'expenses',
  'purchaseValue2',
  'buyingPrice',
  'strikePrice',
  'basicPrice',
  'purchaseAmount',
  'independentAppraisalAmount',
  'plannedDividends',
  'actualDividends',
  'personalAppraisal',
  'independentAppraisalValue',
  'profitability',
  'profitabilityPlan',
  'profitabilityFact',
];

const keyToDelete = 'calculatedValue';

const migrateCalculatedValue = (
  data: CurrentMigrationCollectionItem,
): MigratedMigrationCollectionItem => {
  const newData = { ...data };

  for (const field of valueFields) {
    const value = newData[field] as Record<string, unknown>;

    if (value && Object.prototype.hasOwnProperty.call(value, keyToDelete)) {
      delete value[keyToDelete];
    }
  }

  return newData;
};

const MIGRATION_OPTIONS: SingleCollectionMigrationOption[] = [
  { collectionName: CollectionName.ASSETS, migrateItemFunction: migrateCalculatedValue },
];

const migrate: MigrationType['migrate'] = (data) => {
  return migrateCollections({
    data,
    migrationOptions: MIGRATION_OPTIONS,
  });
};

export const migration7: MigrationType = {
  migrate,
  version: 8,
};
